import { CollectionViewer, DataSource } from '@angular/cdk/collections';

import { Observable, Subject, merge } from 'rxjs';

import { Store } from '@ngrx/store';

import { AppState, Selectors, Actions } from 'store/root-reducer';

import { Customer, CustomerRisk, CustomerStatus, CustomerIntegrationStatus } from 'modules/shared/models/customer.models';
import {
  CustomerFilter, SearchCustomerStatusOptions, SearchCustomerRiskRatingOptions,
  SearchCustomerRecordTypeOptions, SearchCustomerIsActiveOptions
} from 'modules/shared/models/filter.models';

import { CustomerResponse, CustomerPayload } from 'store/models/customer.models';
import { map, takeUntil } from 'rxjs/operators';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

// https://blog.angular-university.io/angular-material-data-table/

export class CustomerDataSource implements DataSource<any> {

  public filters: CustomerFilter;
  public customerName: string;
  public sort: MatSort;
  public paginator: MatPaginator;
  private searchText: string;
  private sortText: string;
  private loadCustomer$: Subject<any> = new Subject();
  constructor(private store: Store<AppState>) { }

  connect(collectionViewer: CollectionViewer): Observable<Customer[]> {

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    /* tslint:disable:deprecation */
    merge(this.sort.sortChange, this.paginator.page)
      /* tslint:enable:deprecation */
      .pipe(
        map((res: Sort | PageEvent) => {
          if ((<Sort>res).active) {
            this.sortText = (<Sort>res).direction === 'asc' ? (<Sort>res).active : `-${(<Sort>res).active}`;
            this.sortText = (<Sort>res).direction ? this.sortText : null;
          }
          this.loadCustomer(this.filters);
        }),
        takeUntil(this.loadCustomer$)
      )
      .subscribe();

    return this.store.select(Selectors.customer.getCustomers).pipe(
      map((res: CustomerResponse) => {
        this.paginator.length = res.count;
        return res.results;
      }),
      takeUntil(this.loadCustomer$)
    );
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.loadCustomer$.next();
    this.loadCustomer$.complete();
  }

  search(str: string) {
    this.searchText = str;
    this.loadCustomer(this.filters);
  }

  loadCustomer(filters?: CustomerFilter, isFilter?: boolean) {
    const customerPayload: CustomerPayload = {
      offset: isFilter ? 0 : this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      searchAll: this.searchText,
      name: this.customerName
    };
    customerPayload.sort = this.sortText;
    this.filters = filters;

    if (this.filters) {
      customerPayload.risks =
        this.filters.risks ? <CustomerRisk[]>this.filters.risks
          .split(',')
          .map((risk: string) => {
            return SearchCustomerRiskRatingOptions[risk].toLowerCase();
          }) : null;
      customerPayload.recordType = this.filters.recordType ? SearchCustomerRecordTypeOptions[this.filters.recordType].toLowerCase() : null;
      customerPayload.active = this.filters.active ? SearchCustomerIsActiveOptions[this.filters.active].toLowerCase() : null;
      customerPayload.status =
        this.filters.status ? <Array<CustomerStatus>>this.filters.status
          .split(',')
          .map((status: string) => {
            return SearchCustomerStatusOptions[status].toLowerCase();
          }) : null;
      customerPayload.integrationStatus =
        this.filters.integrationStatus ? <Array<CustomerIntegrationStatus>>this.filters.integrationStatus
          .split(',')
          .map((status: string) => {
            return SearchCustomerStatusOptions[status].toLowerCase();
          })
          : null;
    }

    this.store.dispatch(new Actions.customer.GetCustomers(customerPayload));
  }
}
